import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=dcd6c0a8"
import script from "./detalle.vue?vue&type=script&lang=js"
export * from "./detalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports